import type { ReactElement } from 'react';
import type { GuestGender } from '@room-mates/shared';

export interface GenderIconProps {
  readonly gender: GuestGender;
  readonly className?: string;
}

/**
 * The standard Venus / Mars / combined trio — small enough to sit inside a
 * picker button, `currentColor` throughout so it follows the button's own
 * text colour (selected vs. not, light vs. dark theme).
 */
export function GenderIcon({ gender, className }: GenderIconProps): ReactElement {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none">
      {gender === 'woman' ? <VenusMark /> : null}
      {gender === 'man' ? <MarsMark /> : null}
      {gender === 'other' ? <CombinedMark /> : null}
    </svg>
  );
}

function VenusMark(): ReactElement {
  return (
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="9" r="6" />
      <line x1="12" y1="15" x2="12" y2="21" />
      <line x1="8" y1="18" x2="16" y2="18" />
    </g>
  );
}

function MarsMark(): ReactElement {
  return (
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10" cy="14" r="6" />
      <line x1="14.2" y1="9.8" x2="20" y2="4" />
      <path d="M14 4 H20 V10" />
    </g>
  );
}

function CombinedMark(): ReactElement {
  return (
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10.5" cy="12.5" r="5.5" />
      <line x1="14.4" y1="8.6" x2="19.5" y2="3.5" />
      <path d="M14 3.5 H19.5 V9" />
      <line x1="10.5" y1="18" x2="10.5" y2="23" />
      <line x1="7" y1="20.5" x2="14" y2="20.5" />
    </g>
  );
}
